<div fxLayout="row" fxLayout.xs="column" style="padding: 5px;">
    <div class="center-vertical" fxFlex="25">
        <mat-select placeholder="User" [formControl]="userControl">
            <input class="col-input-filter" [formControl]="userInputControl">
            <mat-option [value]="0">Choose</mat-option>
            <mat-option [value]="result['id_user']" *ngFor="let result of allUsers; let i = index">{{result['first_name']}} {{result['last_name']}} ({{result['email']}})</mat-option>
        </mat-select>
    </div>
    <div class="separator"></div>
    <div class="center-vertical" fxFlex="25">
        <div class="date-input">
            <mat-date-range-input [rangePicker]="picker">
                <input matStartDate [formControl]="startDateInputControl" placeholder="Start">
                <input matEndDate [formControl]="endDateInputControl" placeholder="End">
            </mat-date-range-input>
            <mat-icon matDatepickerToggleIcon fontIcon="close_small" style="font-size: 18px; display: flex; align-items: center;" (click)="resetDate()"></mat-icon>
            <mat-datepicker-toggle [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </div>
    </div>
    <div class="separator"></div>
    <div class="center-vertical" fxFlex="10">
        <nav style="z-index: 10000;">
            <ul style="margin: 0; display: flex; "> 
                <li> <mat-icon style="cursor: pointer; margin-right: 20px; color: var(--primary); size: 40px;" aria-hidden="false" fontIcon="bar_chart"></mat-icon>
                    <ul style="width: 800px; right: -200px; padding: 10px; color: black; box-shadow: inset 0 0 12px 12px whitesmoke, inset 0 0 3px 2px whitesmoke; border: 1px solid silver;"> 
                        <div class="class-erea" fxLayout="row" fxLayout.xs="column">
                            <div class="class-mat-field" fxFlex="50">
                                <h3 class="stat-title">Current month Splitters</h3>
                                <canvas class="spliting-podium" height="250"></canvas>
                            </div>
                            <div class="separator"></div>
                            <div class="class-mat-field" fxFlex="50">
                                <h3 class="stat-title">Current month Editors Words</h3>
                                <canvas class="editing-podium" height="260"></canvas>
                            </div>
                        </div>
                    </ul>     
                </li>
            </ul>
        </nav>
    </div>
    <div class="center-vertical" fxFlex="15">
        <div style="position: relative; display: flex; margin-left: auto; align-items: center; ">
            <span class="switch-toggle" [ngClass]="{'switch-checked': onlyLastWave}" (click)="toggleOnlyCurrentWaves()">
              <small></small>
            </span>
            <label class="filter-label">My projects</label>
        </div>
    </div>
    <div class="separator"></div>
    <div class="class-mat-field" fxFlex="25"  fxLayoutAlign="center center">
        <button class="button-validate-small" (click) = "chargeData()">Validate</button>
    </div>
</div>

<div class="horizontal" fxLayout="row" style="padding: 5px;">
    <div class="center-vertical" fxFlex="50%">Project: {{this.showedRows.length}} - Content: {{totalContent}} - Classified: {{totalCLassified}} - Edited: {{totalEdited}} - Words: {{totalWords}}</div>
    <div class="center-vertical" fxFlex="50%">
        <input class="float-right col-input" style="width: 180px; margin-left: auto" (keyup)="applyFilterLocal($event.target, 'all_column')" placeholder="Search">
    </div>
</div>

<div class="table_div" style="height: calc(100% - 90px);">
    <table class="fixed-column-table">
        <thead>
            <tr>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'id', 'number')"></mat-icon>
                    <div class="column-name">Id</div>
                    <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'id')">
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'user_supply_wave', 'string')"></mat-icon>
                    <div class="column-name">Supplier</div>
                    <mat-select placeholder="Choose" style="height: 22px;" (selectionChange)="applyFilterLocal($event, 'user_supply_wave')">
                        <mat-option [value]="''">ALL</mat-option>
                        <mat-option [value]="el" *ngFor="let el of suppliers">{{el}}</mat-option>
                    </mat-select>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'creator', 'string')"></mat-icon>
                    <div class="column-name">Creator</div>
                    <mat-select placeholder="Choose" style="height: 22px;" (selectionChange)="applyFilterLocal($event, 'creator')">
                        <mat-option [value]="''">ALL</mat-option>
                        <mat-option [value]="el" *ngFor="let el of creators">{{el}}</mat-option>
                    </mat-select>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'user_split_wave', 'string')"></mat-icon>
                    <div class="column-name">Spl. Cla.</div>
                    <mat-select placeholder="Choose" style="height: 22px;" (selectionChange)="applyFilterLocal($event, 'user_split_wave')">
                        <mat-option [value]="''">ALL</mat-option>
                        <mat-option [value]="el" *ngFor="let el of splitterWave">{{el}}</mat-option>
                    </mat-select>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'user_edit_wave', 'string')"></mat-icon>
                    <div class="column-name">Editor</div>
                    <mat-select placeholder="Choose" style="height: 22px;" (selectionChange)="applyFilterLocal($event, 'user_edit_wave')">
                        <mat-option [value]="''">ALL</mat-option>
                        <mat-option [value]="el" *ngFor="let el of editorWave">{{el}}</mat-option>
                    </mat-select>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'project_name', 'string')"></mat-icon>
                    <div class="column-name">Project Name</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'project_name')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'nb_raw', 'number')"></mat-icon>
                    <div class="column-name">Cont. Raw</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'nb_raw')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'nb_content', 'number')"></mat-icon>
                    <div class="column-name">Nb Content</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'nb_content')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'nb_classified', 'number')"></mat-icon>
                    <div class="column-name">Cont. Classified</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'nb_classified')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'nb_cleaned', 'number')"></mat-icon>
                    <div class="column-name" style="white-space: nowrap;">Cont. Edited</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'nb_cleaned')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'nb_imported', 'number')"></mat-icon>
                    <div class="column-name">Nb uploaded</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'nb_imported')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'nb_word', 'number')"></mat-icon>
                    <div class="column-name">Nb Words</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'nb_word')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'last_edition', 'date')"></mat-icon>
                    <div class="column-name">Last Edition</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'last_edition')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'state', 'string')"></mat-icon>
                    <div class="column-name">State</div>
                    <mat-select placeholder="Choose" style="height: 22px;" (selectionChange)="applyFilterLocal($event, 'state')">
                        <mat-option [value]="''">ALL</mat-option>
                        <mat-option [value]="'editing'">editing</mat-option>
                        <mat-option [value]="'splitting'">splitting</mat-option>
                        <mat-option [value]="'unknown'">unassigned</mat-option>
                        
                    </mat-select>
                </th>
                <th></th>
            </tr>
        </thead>
        <tbody #row_tbody *ngFor="let row of showedRows; let i = index">
            <tr>
                <td>{{ row['id'] }}</td>
                <td matTooltip="{{ row['supplier_description'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">
                    <div class="vague-mark" style="color: var(--orange);">{{ row['supply_wave'] }}</div>
                    <div>{{ row['supplier'] }}</div>
                </td>
                <td class="text-style hover-title" matTooltip="{{ row['creator'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['creator'] }}</td>
                <td style="position: relative">
                    <div class="vague-mark" style="color: var(--primary2);">{{ row['split_wave']}}</div>
                    <div>{{ row['splitter'] }}</div>
                </td>
                <td style="position: relative">
                    <div class="vague-mark" style="color: var(--primary1);">{{ row['edit_wave'] }}</div>
                    <div>{{ row['editor'] }}</div>
                </td>
                <td matTooltip="{{ row['project_name'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['project_name'] }}</td>
                <td style="padding: 1px;">
                    <div class="progress" title="{{row['raw_percent']}}%">
                        <div class="progress-bar" [ngStyle]="{'width': row['raw_percent'] + '%', 'background-color': '#BFE8E3'}"></div>
                        <span>({{row['nb_extracted']}} / {{row['nb_raw']}})</span>
                    </div>
                </td>
                <td>{{ row['nb_content'] }}</td>
                <td style="padding: 1px;">
                    <div class="progress" title="{{row['classified_percent']}}%">
                        <div class="progress-bar" [ngStyle]="{'width': row['classified_percent'] + '%', 'background-color': 'var(--primary2)'}"></div>
                        <span>{{row['classified_percent']}}% ({{row['nb_classified']}})</span>
                    </div>
                </td>
                <td style="padding: 1px;">
                    <div class="progress" title="{{row['edited_percent']}}%">
                        <div class="progress-bar" [ngStyle]="{'width': row['edited_percent'] + '%', 'background-color': 'var(--primary1)'}"></div>
                        <span>{{row['edited_percent']}}% ({{row['nb_edited']}})</span>
                    </div>
                </td>
                <td style="padding: 1px;">
                    <div class="progress" title="{{row['imported_percent']}}%">
                        <div class="progress-bar" [ngStyle]="{'width': row['imported_percent'] + '%', 'background-color': '#C7EDE8'}"></div>
                        <span>{{row['imported_percent']}}% ({{row['nb_imported']}})</span>
                    </div>
                </td>
                <td style="white-space: nowrap;">{{ row['nb_word']}}</td>
                <td style="white-space: nowrap;">{{ row['last_edition']}}</td>
                <td style="white-space: nowrap;">{{ row['state'] }}</td>
                <td class="to_skip_element">
                    <div style="display: flex;">
                        <mat-icon  sorted="" fontIcon="open_in_new" style="color: gray; font-size: 20px;" (click)="openSplitingEditing(row)"></mat-icon>
                        <mat-icon  sorted="" fontIcon="more_vert" style="color: gray; font-size: 20px;" (click)="projectOption(row)"></mat-icon>
                    </div>
                </td>
            </tr>
        </tbody>
        <tbody *ngIf="showedRows.length === 0">
            <tr ><td colspan="15" style="text-align: center;">No matching records found</td></tr>
        </tbody>
    </table>
</div>